export const navigation = () => {
    const topNavItems = document.querySelectorAll(".top-menu-item");
    const menus = document.querySelectorAll('.menu');
    const screenOverlay = document.getElementById('screen-overlay');

    const submenuItems = document.querySelectorAll(".submenu-list .level-2");
    const submenuWrappers = document.querySelectorAll(".submenu-content");

    function closeMenus() {
        menus.forEach((menu) => { menu.classList.remove('active')})
        topNavItems.forEach((menu) => { menu.classList.remove('active')})
        submenuWrappers.forEach((menu) => { menu.classList.remove('active')})
        submenuItems.forEach((menu) => { menu.classList.remove('active')})
        screenOverlay.classList.remove('active');
    }

    const handleClick = ((event) => {
        if (Array.from(topNavItems).includes(event.target)) {
            const isActive = event.target.classList.contains('active');
            closeMenus();
            const relatedMenu = document.getElementById(event.target.dataset.id);
            if (!isActive) {
                event.target.classList.add('active');
                relatedMenu.classList.add('active');
                const submenus = relatedMenu.querySelectorAll('.submenu-content');
                if (submenus.length > 0) {
                    submenus[0].classList.add('active');
                    relatedMenu.querySelectorAll('.submenu-list .level-2')[0].classList.add('active');
                }
                screenOverlay.classList.add('active');
            }
        } else {
            closeMenus();
        }
    });
    document.addEventListener('click', handleClick);

    document.querySelectorAll('a[href="#"]').forEach((link) => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
        });
    });

    let returnTimeout;

    submenuItems.forEach((item) => {
        item.addEventListener("mouseenter", () => {
            clearTimeout(returnTimeout);

            submenuItems.forEach((i) => i.classList.remove("active"));
            submenuWrappers.forEach((i) => i.classList.remove("active"));
            item.classList.add('active');

            const dataMenu = item.dataset.menu;
            const submenuToActivate = document.querySelectorAll('.submenu-content[data-menu-content=' + dataMenu + ']')[0];

            submenuToActivate.classList.add("active");
        });
    });
}
